module.exports = __webpack_public_path__ + "static/media/home.77178950.svg";